import React from 'react';

interface SteelmanTeaserProps {
  teaser: string;
  personaColor: string;
}

const SteelmanTeaser: React.FC<SteelmanTeaserProps> = ({ teaser, personaColor }) => {
  return (
    <div
      className="rounded-[10px] p-4 mb-5 flex items-start gap-2.5"
      style={{
        background: `${personaColor}0F`,
        border: `1px solid ${personaColor}26`
      }}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke={personaColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="shrink-0 mt-0.5"
      >
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
        <polyline points="9 11 12 14 22 4" />
      </svg>
      <p
        className="text-[14px] italic text-[#475569] leading-relaxed"
        style={{ fontFamily: "'Source Serif 4', Georgia, serif", lineHeight: '1.6' }}
      >
        {teaser}
      </p>
    </div>
  );
};

export default SteelmanTeaser;
